var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCheckSolid = function SvgUserCheckSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.707 15.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L18 18.586l3.293-3.293a1 1 0 0 1 1.414 0ZM6.786 14.5h4.437c.12 0 .261 0 .387.01.145.012.353.042.571.154a1.5 1.5 0 0 1 .655.655c.111.218.142.426.154.571.01.125.01.268.01.387v3.946c0 .12 0 .262-.01.387a1.51 1.51 0 0 1-.154.571 1.5 1.5 0 0 1-.655.655 1.508 1.508 0 0 1-.571.154c-.125.01-.268.01-.387.01-2.877-.001-5.755-.015-8.632 0-.072 0-.215.001-.351-.023a1.5 1.5 0 0 1-1.217-1.216C.999 20.623 1 20.48 1 20.41c.003-.591-.027-1.194.076-1.778a5 5 0 0 1 4.056-4.056c.432-.076.927-.076 1.654-.076ZM4.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z",
    fill: "currentcolor"
  })));
};
export default SvgUserCheckSolid;